import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IEmbedderTerminalService = ( createDecorator('embedderTerminalService'));
export { IEmbedderTerminalService };
